import React from 'react';
import { Sparkles } from 'lucide-react';
import { ABLE_COLORS } from '../constants';

/**
 * ReviewBadge - Shows combined count of items needing review
 * 
 * Combines facts + aliases into single badge
 */
export default function ReviewBadge({ count, onClick }) {
  if (count === 0) {
    // Still show button but without badge
    return (
      <button
        onClick={onClick}
        style={{
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          padding: '8px',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          opacity: 0.6
        }}
        title="Review learned facts and aliases"
      >
        <Sparkles size={20} color={ABLE_COLORS.warm} />
      </button>
    );
  }

  return (
    <button
      onClick={onClick}
      style={{
        position: 'relative',
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '8px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px'
      }}
      title={`${count} item${count === 1 ? '' : 's'} to review`}
    >
      <Sparkles size={20} color={ABLE_COLORS.warm} />
      
      {/* Badge */}
      <span style={{
        position: 'absolute',
        top: '2px',
        right: '2px',
        background: ABLE_COLORS.semantic.error,
        color: 'white',
        fontSize: '10px',
        fontWeight: '700',
        minWidth: '16px',
        height: '16px',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 4px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
      }}>
        {count > 99 ? '99+' : count}
      </span>
    </button>
  );
}
